//#region IMPORT
import React, { useEffect } from 'react';
import { BusinessGridGridCommon } from '../../../../../Components/BusinessGridGridCommon';
import GridFunctions from '../../../../../Services/agGrid/ag-Grid-functions';
import {
  Typography,
  Paper,
  Button,
  Box,
  TextField,
  Chip,
  Stack,
  CircularProgress,
  LinearProgress,
} from '@mui/material';
import { Dialog } from '../../../../../Components/MUIs';
import { Download as DownloadIcon } from '@mui/icons-material';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { useSelector } from 'react-redux';
import { getColumnDefs1 } from './TRA_NEW_05_ColumnDefs';
import { toPreviewSrc } from '../../../../../util';
import FilePreview from '../../../../../Components/FilePreview/FilePreview';

function TRA_NEW_05(props) {
  // 현재 클릭된 행의 SESSION_CD를 추적하기 위한 ref
  const clickedSessionCdRef = React.useRef(null);
  const searchInfo = useSelector((state) => state.SearchInfo);

  const columnDefs1 = getColumnDefs1(props);
  const audioPath = props.selectedRowData1?.[0]?.meetPath;
  const audioUrl = toPreviewSrc(audioPath);
  const tbmContent = props.selectedRowData1?.[0]?.tbmContent ?? '';
  // 한라(HAN) 회의록: tbmContent에 {locationContents, hazards, countermeasure} JSON이 저장됨
  // 구버전(자유 텍스트) 데이터와 호환을 위해 파싱 실패 시 null 처리 후 원문 그대로 표시
  const parsedTbmContent = React.useMemo(() => {
    if (!tbmContent) return null;
    try {
      const parsed = JSON.parse(tbmContent);
      if (parsed && typeof parsed === 'object') return parsed;
      return null;
    } catch (e) {
      return null;
    }
  }, [tbmContent]);

  //#region AuthButton 이벤트
  useEffect(() => {
    if (props.filterClick5) {
      if (!props.validateSelection()) {
        props.setFilterClick5(false);
        return;
      }

      props.gridRef1.current.api.setQuickFilter(searchInfo.searchText);
      props.setFilterClick5(false);
    }
    if (props.searchClick5) {
      props.ResetLogic1();
      if (!props.validateSelection()) {
        props.setSearchClick5(false);
        return;
      }

      props.SearchLogic1();
      props.setSearchClick5(false);
    }
    if (props.addClick5) {
      if (!props.validateSelection()) {
        props.setAddClick5(false);
        return;
      }

      GridFunctions.addClick(props.gridRef1);
      props.setAddClick5(false);
    }
    if (props.saveClick5) {
      if (!props.validateSelection()) {
        props.setSaveClick5(false);
        return;
      }

      props.SaveLogic1();
      props.setSaveClick5(false);
    }
    if (props.deleteClick5) {
      if (!props.validateSelection()) {
        props.setDeleteClick5(false);
        return;
      }

      props.DeleteLogic1();
      props.setDeleteClick5(false);
    }
    if (props.printClick5) {
      if (!props.validateSelection()) {
        props.setPrintClick5(false);
        return;
      }

      props.PrintLogic1();
      props.setPrintClick5(false);
    }
    if (props.listClick5) {
      if (!props.validateSelection()) {
        props.setListClick5(false);
        return;
      }

      props.setModalToggle3(true);
      props.setListClick5(false);
    }
  }, [
    props.filterClick5,
    props.searchClick5,
    props.addClick5,
    props.saveClick5,
    props.deleteClick5,
    props.printClick5,
    props.listClick5,
  ]);
  //#endregion

  return (
    <React.Fragment>
      <BusinessGridGridCommon
        gridId={props.gridId1}
        getRowId1={(params) => params.data.no}
        title1={'교육현황'}
        addYn1="N"
        deleteYn1="Y"
        leftSize={60}
        rightSize={40}
        gridRef1={props.gridRef1}
        columnDefs1={columnDefs1}
        rowData1={props.rowData1}
        setSelectedRowData1={props.setSelectedRowData1}
        setChangedRowData1={props.setChangedRowData1}
        onCellClicked1={(e) => {
          const currentSessionCd = e.data.sessionCd;
          // 이미 클릭된 행을 다시 클릭한 경우 다시 생성하지 않음
          if (clickedSessionCdRef.current === currentSessionCd) {
            return;
          }
          // 새로운 행을 클릭한 경우에만 일지 미리보기 생성
          clickedSessionCdRef.current = currentSessionCd;
          props.sessionCdRef.current = currentSessionCd;

          props.PreviewLogic1(e.data);
        }}
        onSelectionChanged1={() => {
          const gridApi = props.gridRef1?.current?.api;
          const selectedNodes = gridApi.getSelectedNodes();
          const selectedData = selectedNodes.map((n) => n.data);

          props.selectedRowNosRef1.current = new Set(
            selectedData.map((r) => r.no)
          );
          props.setSelectedRowData1(selectedData);
        }}
        refreshClick1={() => {
          if (!props.validateSelection()) return;

          props.SearchLogic1();
        }}
        rightContentOnly={
          <Box
            sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
          >
            <Typography sx={{ fontWeight: 'bold', mb: 1, color: '#2CA900' }}>
              일지 미리보기
            </Typography>
            <Box
              sx={{
                flex: 1,
                minHeight: 0,
                overflow: 'hidden',
                position: 'relative',
              }}
            >
              {props.previewLoading ? (
                <>
                  <LinearProgress
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      zIndex: 2,
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      inset: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      gap: 1.5,
                      bgcolor: 'rgba(255,255,255,0.88)',
                      zIndex: 1,
                    }}
                  >
                    <CircularProgress size={40} />
                    <Typography variant="body2" color="text.secondary">
                      일지 미리보기 생성 중입니다…
                    </Typography>
                  </Box>
                </>
              ) : null}
              <FilePreview
                selectedRowData={props.previewRowData}
                fileNameField="saveName"
                filePathField="previewFilePath"
                filePreviewHeight="100%"
              />
            </Box>
          </Box>
        }
        deleteClick1={(e) => {
          const newRowExists = props.selectedRowData1.some(
            (row) => row.newYn === 'Y'
          );

          if (!newRowExists) {
            props.MarkedForDeletion1(props.selectedRowData1);
          } else {
            props.NewYnErrorMsg();
          }
        }}
      />
      {props.modalToggle1 && (
        <Dialog
          title={'내용 보기'}
          open={props.modalToggle1}
          onClose={() => {
            props.setModalToggle1(false); // 모달 닫기
          }}
          contentSx={{ display: 'flex', flexDirection: 'column' }}
          closeButtonName={'닫기'}
          useSaveAfterClose={true}
          maxWidth={false}
          PaperProps={{
            sx: {
              display: 'flex',
              flexDirection: 'column',
              p: 3,
              width: '70vw',
              maxWidth: '1080px',
              minWidth: '760px',
              height: '88vh',
              bgcolor: '#f9fafb',
            },
          }}
          previewRender={props.PreviewRender}
          onSave={() => {
            const api = props.gridRef1?.current?.api;
            const clickedRowData = props.rowClickData.current;
            const uploadedFile = props.previewUrl?.file;

            if (!api || !clickedRowData || !uploadedFile?.name) {
              console.warn('파일명 또는 선택된 행이 없습니다.');
              return;
            }

            let targetRowNode = null;
            api.forEachNode((node) => {
              if (node.data === clickedRowData) {
                targetRowNode = node;
              }
            });

            if (targetRowNode) {
              const fileName = uploadedFile.name;

              targetRowNode.setDataValue('FILE_NAME', fileName);
              targetRowNode.setDataValue('mapFile', uploadedFile);
            } else {
              console.warn('대상 행을 찾을 수 없습니다.');
            }

            // 모달 닫기 및 상태 초기화
            props.setModalToggle1(false);
            props.setPreviewFile(null);
          }}
          content={
            <Box
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                pt: 1,
                pr: 1,
                gap: 2,
                overflowY: 'auto',
              }}
            >
              {/* 상단 영역 */}
              <Paper
                elevation={2}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                  p: 2.5,
                  borderRadius: 2,
                  border: '1px solid #e5e7eb',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 2,
                    flexWrap: 'wrap',
                  }}
                >
                  <Typography sx={{ fontWeight: 600, color: '#374151' }}>
                    회의 녹음 파일
                  </Typography>
                  <Box
                    sx={{
                      flex: 1,
                      minWidth: '280px',
                      px: 1.5,
                      py: 1,
                      borderRadius: 1.5,
                      bgcolor: '#f3f4f6',
                      color: '#4b5563',
                      border: '1px solid #e5e7eb',
                      fontSize: '0.9rem',
                    }}
                  >
                    {audioPath ? audioPath.split('/').pop() : '파일 없음'}
                  </Box>
                  <Button
                    variant="contained"
                    color="success"
                    disabled={!audioPath}
                    onClick={() => props.DownloadLogic1(audioPath)}
                    startIcon={<DownloadIcon />}
                    sx={{ whiteSpace: 'nowrap', px: 2 }}
                  >
                    파일 다운로드
                  </Button>
                </Box>
                <Box
                  sx={{
                    p: 1.5,
                    borderRadius: 2,
                    border: '1px solid #e5e7eb',
                    bgcolor: '#fff',
                  }}
                >
                  <AudioPlayer
                    src={audioUrl}
                    autoPlay={false}
                    customAdditionalControls={[]} // 불필요한 버튼 제거
                    style={{ width: '100%' }}
                  />
                </Box>
              </Paper>

              {/* 내용 영역 */}
              <Paper
                elevation={2}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  flexShrink: 0,
                  gap: 1.5,
                  p: 2.5,
                  borderRadius: 2,
                  border: '1px solid #e5e7eb',
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, color: '#374151' }}
                >
                  내용
                </Typography>
                {parsedTbmContent ? (
                  <Stack spacing={2}>
                    {/* 장소별 작업 내용 */}
                    <Box>
                      <Typography
                        sx={{ fontWeight: 600, fontSize: '0.85rem', color: '#6b7280', mb: 1 }}
                      >
                        작업 내용
                      </Typography>
                      {Object.keys(parsedTbmContent.locationContents ?? {}).length ? (
                        <Stack spacing={1}>
                          {Object.entries(parsedTbmContent.locationContents).map(
                            ([loc, content]) => (
                              <Box
                                key={loc}
                                sx={{
                                  p: 1.5,
                                  borderRadius: 1.5,
                                  border: '1px solid #e5e7eb',
                                  borderLeft: '3px solid #2F80ED',
                                  bgcolor: '#fff',
                                }}
                              >
                                <Typography
                                  sx={{ fontWeight: 700, fontSize: '0.8rem', color: '#2F80ED', mb: 0.5 }}
                                >
                                  {loc}
                                </Typography>
                                <Typography sx={{ fontSize: '0.9rem', color: '#374151', whiteSpace: 'pre-wrap' }}>
                                  {content || '-'}
                                </Typography>
                              </Box>
                            )
                          )}
                        </Stack>
                      ) : (
                        <Typography sx={{ fontSize: '0.9rem', color: '#9ca3af' }}>
                          등록된 작업 내용이 없습니다.
                        </Typography>
                      )}
                    </Box>

                    {/* 잠재위험요인 */}
                    <Box>
                      <Typography
                        sx={{ fontWeight: 600, fontSize: '0.85rem', color: '#6b7280', mb: 1 }}
                      >
                        잠재위험요인
                      </Typography>
                      {parsedTbmContent.hazards?.length ? (
                        <Stack direction="row" flexWrap="wrap" gap={1}>
                          {parsedTbmContent.hazards.map((hz, idx) => (
                            <Chip
                              key={`${hz}-${idx}`}
                              label={hz}
                              size="small"
                              sx={{
                                bgcolor: 'rgba(235,87,87,0.1)',
                                color: '#EB5757',
                                fontWeight: 600,
                              }}
                            />
                          ))}
                        </Stack>
                      ) : (
                        <Typography sx={{ fontSize: '0.9rem', color: '#9ca3af' }}>
                          선택된 잠재위험요인이 없습니다.
                        </Typography>
                      )}
                    </Box>

                    {/* 대책 */}
                    <Box>
                      <Typography
                        sx={{ fontWeight: 600, fontSize: '0.85rem', color: '#6b7280', mb: 1 }}
                      >
                        잠재위험요인에 대한 대책
                      </Typography>
                      <Box
                        sx={{
                          p: 1.5,
                          borderRadius: 1.5,
                          border: '1px solid #e5e7eb',
                          bgcolor: '#fff',
                          minHeight: '48px',
                        }}
                      >
                        <Typography sx={{ fontSize: '0.9rem', color: '#374151', whiteSpace: 'pre-wrap' }}>
                          {parsedTbmContent.countermeasure || '-'}
                        </Typography>
                      </Box>
                    </Box>
                  </Stack>
                ) : (
                  <TextField
                    fullWidth
                    multiline
                    minRows={4}
                    maxRows={8}
                    value={tbmContent}
                    placeholder="내용 없음"
                    InputProps={{ readOnly: true }}
                    sx={{
                      '& .MuiInputBase-root': {
                        bgcolor: '#f9fafb',
                      },
                      '& .MuiInputBase-input': {
                        cursor: 'default',
                      },
                    }}
                  />
                )}
              </Paper>

              {/* 미리보기 영역 */}
              <Paper
                elevation={2}
                sx={{
                  p: 2.5,
                  flexShrink: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: 2,
                  border: '1px solid #e5e7eb',
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1.5, fontWeight: 600, color: '#374151' }}
                >
                  TBM 사진
                </Typography>
                <Box
                  sx={{
                    border: '1px dashed #cbd5e1',
                    borderRadius: 2,
                    minHeight: '240px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'auto',
                    bgcolor: '#fff',
                    p: 2,
                  }}
                >
                  {props.PreviewRender
                    ? props.PreviewRender()
                    : '미리보기 영역'}
                </Box>
              </Paper>
            </Box>
          }
        />
      )}
    </React.Fragment>
  );
}

export default TRA_NEW_05;
